"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useIntlKeyStore = _interopRequireDefault(require("./useIntlKeyStore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useIntlKey = (passedIntlKey, passedIntlNS) => {
  const getKey = (0, _useIntlKeyStore.default)(state => state.getKey);
  let intlKey;
  if (passedIntlKey) {
    intlKey = passedIntlKey;
  } else if (passedIntlNS) {
    intlKey = getKey(passedIntlNS);
  } else {
    intlKey = getKey();
  }
  if (!intlKey) {
    throw new Error('Stripes kint components requires an intl key to be either configured via `addKey` from `useIntlKeyStore` or passed directly into components');
  }
  return intlKey;
};
var _default = exports.default = useIntlKey;